import SeatingMapService from "../../services/SeatingMapService";
import { orderComplete } from "./orderActions";
export const GET_SEATING_MAP_REQUEST = "GET_SEATING_MAP_REQUEST";
export const GET_SEATING_MAP_SUCCESS = "GET_SEATING_MAP_SUCCESS";
export const GET_SEATING_MAP_ERROR = "GET_SEATING_MAP_ERROR";

export const GET_SEATING_MAPS_REQUEST = "GET_SEATING_MAPS_REQUEST";
export const GET_SEATING_MAPS_SUCCESS = "GET_SEATING_MAPS_SUCCESS";
export const GET_SEATING_MAPS_ERROR = "GET_SEATING_MAPS_ERROR";

export const SAVE_TICKET_MAPPING_REQUEST = "SAVE_TICKET_MAPPING_REQUEST";
export const SAVE_TICKET_MAPPING_SUCCESS = "SAVE_TICKET_MAPPING_SUCCESS";
export const SAVE_TICKET_MAPPING_ERROR = "SAVE_TICKET_MAPPING_ERROR";
export const SAVE_TICKET_MAPPING_CONFLICT = "SAVE_TICKET_MAPPING_CONFLICT";

export const SEATING_MAP_REQUIRED = "SEATING_MAP_REQUIRED";
export const RESET_SEATING_MAP_EVAL = "RESET_SEATING_MAP_EVAL";
import { Router } from "preact-router";

export const saveTicketMapping = (
  ticketMappingData,
  eventSlug,
  order,
  seatingMapId,
  event
) => {
  return dispatch => {
    const eventId = event._id;
    const orderId = order._id;
    const eventDateId = order.eventDateId;
    dispatch({ type: SAVE_TICKET_MAPPING_REQUEST });
    SeatingMapService.saveTicketMapping(
      ticketMappingData,
      seatingMapId,
      eventId,
      eventDateId
    )
      .then(result => {
        //{conflict: true, conflicts: conflictedSeats}
        if (result.conflict) {
          dispatch({
            type: SAVE_TICKET_MAPPING_CONFLICT,
            conflicts: result.conflicts
          });
        } else {
          if (
            order.status === "complete" ||
            order.totals.total <= 0 ||
            result.orderComplete
          ) {
            orderComplete(eventSlug, event, order, false);
          } else {
            dispatch({ type: SAVE_TICKET_MAPPING_SUCCESS });
            Router.route(`/${eventSlug}/payment/${orderId}`);
          }
        }
      })
      .catch(err => {
        dispatch({ type: SAVE_TICKET_MAPPING_ERROR, error: err });
      });
  };
};

export const getSeatingMap = (eventId, seatingMapId) => {
  return dispatch => {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    SeatingMapService.get(eventId, seatingMapId)
      .then(seatingMap => {
        dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap: seatingMap });
      })
      .catch(err => {
        dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
      });
  };
};

export const getSeatingMapPublic = (eventId, token, orderId) => {
  return dispatch => {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    SeatingMapService.getPublic(eventId, token, orderId)
      .then(seatingMap => {
        dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap: seatingMap });
      })
      .catch(err => {
        dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
      });
  };
};

export const getAllSeatingMaps = (eventId, eventDateId) => {
  return dispatch => {
    dispatch({ type: GET_SEATING_MAPS_REQUEST });
    SeatingMapService.getAll(eventId, eventDateId)
      .then(seatingMaps => {
        dispatch({ type: GET_SEATING_MAPS_SUCCESS, seatingMaps: seatingMaps });
      })
      .catch(err => {
        dispatch({ type: GET_SEATING_MAPS_ERROR, error: err });
      });
  };
};

export const resetSeatingMapEvaluation = () => {
  return dispatch => {
    dispatch({ type: RESET_SEATING_MAP_EVAL });
  };
};

export const setSeatingMapRequired = required => {
  return dispatch => {
    dispatch({ type: SEATING_MAP_REQUIRED, required: required });
  };
};



// WEBPACK FOOTER //
// ./state/actions/seatingMapActions.js